import { render, staticRenderFns } from "./OrganizationProofStatus.vue?vue&type=template&id=6adb68e4&"
import script from "./OrganizationProofStatus.vue?vue&type=script&lang=ts&"
export * from "./OrganizationProofStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports